import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.survey.invalid');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-survey-invalid',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.survey.invalid/view.scss */
:host {
  display: block;
  width: 100%;
}`],
})
export class PageSurveyInvalidComponent implements OnInit {
    public reason: string = 'not_found';
    public title: string = '잘못된 URL입니다';
    public message: string = '설문 URL을 다시 확인해주세요.';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.reason = WizRoute.segment.reason || 'not_found';
        if (this.reason === 'expired') {
            this.title = '만료된 URL입니다';
            this.message = '설문 응답 기간이 지났습니다. 담당자에게 문의해주세요.';
        } else if (this.reason === 'completed') {
            this.title = '이미 제출된 설문입니다';
            this.message = '해당 설문은 이미 제출 완료되었습니다.';
        } else {
            this.title = '잘못된 URL입니다';
            this.message = '설문 URL을 다시 확인해주세요.';
        }
        await this.service.render();
    }
}

export default PageSurveyInvalidComponent;